import countriesPhoneCodes from '../../modules/marketing/utils/countriesPhoneCodes';

const addCountryCodeToPhoneNumber = (e) => {
  const countrySelect = e.target;
  const phoneInput = document.getElementById('custom_form_entry_mobile_no');
  const countryCodeMapping = countriesPhoneCodes;

  if (!phoneInput || !countrySelect || !countryCodeMapping) {
    return;
  }

  const phoneInputValue = phoneInput.value;
  const countryCode = countrySelect.value;
  const countryPhoneCodes = Array.from(countryCodeMapping.values());

  if (!countryCode || (phoneInputValue && countryPhoneCodes.indexOf(phoneInputValue) === -1)) {
    return;
  }

  const countryCallingCode = countryCodeMapping.get(countryCode);

  if (countryCallingCode) {
    phoneInput.value = countryCallingCode;
  } else {
    phoneInput.value = '';
  }
};

const handleInputTabs = (event) => {
  if (event.key !== 'Tab') { return; }

  const leadFormElements = Array.from(event.target.form.querySelectorAll('input, select'));
  const currentIndex = leadFormElements.findIndex(e => e.name === event.target.name);
  const nextInput = leadFormElements[currentIndex + 1];
  if (nextInput?.id === 'custom_form_entry_mobile_no') {
    event.preventDefault();
    nextInput.focus();
    nextInput.setSelectionRange(nextInput.value.length, nextInput.value.length);
  }
};

export default () => {
  const countrySelect = document.querySelector('select[id="custom_form_entry_country"]');
  const leadForm = document.getElementById('new_custom_form_entry');
  const phoneField = document.getElementById('custom_form_entry_mobile_no');

  if (countrySelect) {
    if (leadForm) {
      // Move country field before phone field
      leadForm.insertBefore(countrySelect.parentNode, phoneField.parentNode);
      leadForm.querySelectorAll('input, select').forEach((formElement) => {
        formElement.addEventListener('keydown', handleInputTabs);
      });
    }

    countrySelect.addEventListener('change', addCountryCodeToPhoneNumber);
  }
};
